// Determine API endpoint based on build mode
// Azure build uses 'guidelines-clone' (test), production uses 'guidelines/v1'
const getApiEndpoint = (): string => {
  const mode = process.env.VUE_APP_MODE;
  return mode === 'azure'  ? 'guidelines-clone' : 'guidelines/v1';
};

export const API_ENDPOINT = getApiEndpoint();
export const API_BASE_URL = "https://td.azure-api.net/";
export const API_FULL_URL = `${API_BASE_URL}${API_ENDPOINT}`;

export const apiConfig = {
    returnRejectedPromiseOnError: true,
    withCredentials: false,
    timeout: 30000,
    baseURL: "https://td.azure-api.net/",
    headers: {      
        "ocp-apim-subscription-key": process.env.VUE_APP_SUBSCRIPTION_KEY,
        "Content-Type": "application/json",
        Accept: "application/json"     
    }
  };